import { render, staticRenderFns } from "./auditDetail.vue?vue&type=template&id=50f96132&scoped=true"
import script from "./auditDetail.vue?vue&type=script&lang=js"
export * from "./auditDetail.vue?vue&type=script&lang=js"
import style0 from "./auditDetail.vue?vue&type=style&index=0&id=50f96132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f96132",
  null
  
)

export default component.exports